<script setup>
import UseVirtualList from '/app/components/externals/vueuse/UseVirtualList.vue';
import { Loading as NNerveLoading } from '@bignerve/ui-core';
import { vInfiniteScroll } from '@vueuse/components';
import { useNeurons } from '/app/queries/gamedash';
import { useAuth } from '/app/composables/auth';
import { computed } from 'vue';
import NeuronEarned from './notification/NeuronEarned.vue';
import { RevealToggle, Reveal } from '/app/components/Reveal';

const props = defineProps({
    role: {
        type: String,
        default: 'overall',
    },
    height: {
        type: String,
        default: '160px',
    },
});

const emit = defineEmits(['scroll']);

const { auth } = useAuth();
const { data, isFetching, fetchNextPage } = useNeurons(auth.user.screen_name, computed(() => ({
    role: props.role,
})));
</script>

<template>
    <div ref="neuronsContent">
        <div v-if="data.length" class="game-dash-list overflow-x-hidden">
            <UseVirtualList v-infinite-scroll="[fetchNextPage, { distance: 200 }]" :list="data" :options="{ itemHeight: 100, overscan: 3 }" :height="height" class="pr-2 sb-tight sb-rounded sb-dust-700 transition-[height] duration-[300]" @scroll="emit('scroll', $event)">
                <template #="{ data: neuron }">
                    <NeuronEarned :detail="neuron" source="gamedash" class="mb-2" />
                </template>
            </UseVirtualList>
        </div>
        <div v-else-if="isFetching" :style="{ height }" class="flex items-center justify-center">
            <NNerveLoading />
        </div>
        <div v-else-if="!data.length" :style="{ height }" class="flex flex-col items-center px-4 text-dust-500">
            <span class="flex flex-1 items-center">{{ $t('component.game-dash.neurons-earned.no-neurons') }}</span>
            <RevealToggle :to="`game-dash:neurons-hint:${role}`" :once="true" label="Explain this" icon="exclamation-circle-solid" class="mb-2" />
            <Reveal :to="`game-dash:neurons-hint:${role}`">
                <p class="self-stretch text-sm text-dust-400">
                    {{ $t('component.game-dash.neurons-earned.no-neurons-hint') }}
                </p>
            </Reveal>
        </div>
    </div>
</template>
